import { PlusIcon } from '@heroicons/react/24/outline';

import { Restricted } from 'containers/Restricted';

import { PrimaryButton } from '@atoms/buttons/PrimaryButton';
import { EmptyKeysIllustration } from '@atoms/illustrations/EmptyKeysIllustration';

import {
  MCP_CREATE_BUTTON_LABEL,
  MCP_EMPTY_CTA_TEST_ID,
  MCP_EMPTY_STATE_MESSAGE,
  MCP_EMPTY_TEST_ID
} from './constants';

import { EMPTY_STATE_MIN_HEIGHT } from '../constants';

type McpEmptyStateProps = {
  onCreate: () => void;
};

export const McpEmptyState = ({ onCreate }: McpEmptyStateProps) => (
  <div
    data-testid={MCP_EMPTY_TEST_ID}
    className={`flex ${EMPTY_STATE_MIN_HEIGHT} flex-1 flex-col items-center justify-center gap-6`}
  >
    <EmptyKeysIllustration
      data-testid="developers_mcp_empty_illustration"
      className="size-[99px]"
    />
    <p className="text-lg font-medium leading-[22px] text-content-strong">
      {MCP_EMPTY_STATE_MESSAGE}
    </p>
    <Restricted requiredPermission="developers:manage">
      <PrimaryButton
        data-testid={MCP_EMPTY_CTA_TEST_ID}
        icon={<PlusIcon className="size-4" />}
        onClick={onCreate}
      >
        {MCP_CREATE_BUTTON_LABEL}
      </PrimaryButton>
    </Restricted>
  </div>
);
